import {useFormContext} from "react-hook-form";
import {SingleValue} from "react-select";

import {SelectField, SelectFieldBaseProps} from "@/components/form/fields/SelectField/SelectField.tsx";
import {ThirdPartyGroupSelect} from "@/components/thirdPartyGroupSelect/ThirdPartyGroupSelect.tsx";
import {ThirdPartyService} from "@/lib/queries/checks.ts";

interface ThirdPartyGroupSelectFieldProps extends SelectFieldBaseProps {
  onChange?: (value: SingleValue<ThirdPartyService>) => void;
}

export const ThirdPartyGroupSelectField = ({name, onChange, ...rest}: ThirdPartyGroupSelectFieldProps) => {
  const {
    setValue,
    formState: {defaultValues},
  } = useFormContext();
  return (
    <SelectField
      name={name}
      {...rest}
      select={
        <ThirdPartyGroupSelect
          name={name}
          onChange={(v) => {
            setValue(name, v, {shouldDirty: true, shouldValidate: true});
            onChange?.(v);
          }}
          defaultValue={defaultValues?.[name]}
        />
      }
    />
  );
};
